import { useMemo } from 'react';

import ElasticBandImg from 'assets/img/svc-demo/1_13_elastic_band.jpg';
import KraftWrapImg from 'assets/img/svc-demo/2_13_kraft_wrap.jpg';
import PaperStripImg from 'assets/img/svc-demo/3_13_paper_strip_2.jpg';
import PolybagImg from 'assets/img/svc-demo/4_13_polybag.jpg';
import ShrinkWrapImg from 'assets/img/svc-demo/5_13_shrink_wrap.jpg';
import PerforateImg from 'assets/img/svc-demo/15_18_perforate.jpg';
import ScoreImg from 'assets/img/svc-demo/16_18_score.jpg';
import LaminateImg from 'assets/img/svc-demo/22_2_laminate.jpg';

export const useSvcImgList = () => {
  const imgList = useMemo(() => {
    return [
      {
        revxTypeId: 13,
        revxId: 1,
        src: ElasticBandImg,
      },
      {
        revxTypeId: 13,
        revxId: 2,
        src: KraftWrapImg,
      },
      {
        revxTypeId: 13,
        revxId: 3,
        src: PaperStripImg,
      },
      {
        revxTypeId: 13,
        revxId: 4,
        src: PolybagImg,
      },
      {
        revxTypeId: 13,
        revxId: 5,
        src: ShrinkWrapImg,
      },
      {
        revxTypeId: 18,
        revxId: 15,
        src: PerforateImg,
      },
      {
        revxTypeId: 18,
        revxId: 16,
        src: ScoreImg,
      },
      {
        revxTypeId: 25,
        revxId: 61,
        src: LaminateImg,
      },
    ];
  }, []);

  return imgList;
};
